import styled from 'styled-components'

export const ContainerButton = styled.button`
    width: 182.81px;
    height: 36.13px;
    background: #9758A6;
    border-radius: 20px;
    border: none;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    text-align: center;
    color: #EEEEEE;
    cursor: pointer;

    &:hover {
        opacity: .8;
    }

    &:active {
        opacity: .6;
    }
`